import axios from 'axios'

const endpointVersion = '/api/v1'
const baseURL = process.env.VUE_APP_END_POINT + endpointVersion
const headers = { 'Content-Type': 'application/json' }

const config = {
  baseURL,
  headers,
  timeout: 0,
  withCredentials: true,
  maxRedirects: 0
};

const instance = axios.create(config)

export const weblinkRequest = axios.create({
  ...config,
  baseURL: process.env.VUE_APP_END_POINT,
});

const externalRequestBaseURL = process.env.VUE_APP_EXTERNAL_END_POINT + endpointVersion + '/tenant'
const externalRequestHeaders = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${process.env.VUE_APP_EXTERNAL_END_POINT_TOKEN}`
}

export const externalRequest = axios.create({
  baseURL: externalRequestBaseURL,
  headers: externalRequestHeaders,
  timeout: 0,
  withCredentials: true,
  maxRedirects: 0
})

export default instance
